import i18n from 'i18next'

export const getNationalIdentificationNumberErrorTranslation = (
	message?: string,
) => {
	switch (message) {
		case 'CaseCprMismatchClientInput':
			return i18n.t(
				'consumerInputs-personalInformationValidation-CaseCprMismatchClientInput-text',
			)
		case 'CaseCprUsedByOtherApplicantClientInputs':
			return i18n.t(
				'consumerInputs-personalInformationValidation-CaseCprUsedByOtherApplicantClientInputs-text',
			)
		case 'CaseCprUsedByOtherApplicantSession':
			return i18n.t(
				'consumerInputs-personalInformationValidation-CaseCprUsedByOtherApplicantSession-text',
			)
		default:
			return i18n.t(
				'consumerInputs-personalInformationValidation-validateCPRMatchFailParring-text',
			)
	}
}
